<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wineForm.validate")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineWineFormValidate :APIbaseURL="APIbaseURL" :wineForm="wineForm" :wineToEdit="wineToEdit" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineWineFormValidate } from 'aveine-wine'
import { WineForm, Wine } from 'aveine-toolbox'
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      wineForm: {},
      wineToEdit: {},
      wineToValidate: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Update',
  components: {
    AveineWineFormValidate
  },
  async beforeCreate() {
    try {
      await WineForm.api().get(`wine-forms/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          params: {
            include:
              'scan.ancestor,' +
              'appellation,' +
              'domain.region.country,' +
              'region,' +
              'country,' +
              'grapes-composes-wine-form.grape.grape-variety,' +
              'edited-wine',
          }
        }
      );
      this.wineForm = await WineForm.query().whereId(this.$route.params.id).withAllRecursive().first();

      if (this.wineForm.edited_wine && this.wineForm.edited_wine.id) {
        await Wine.api().get(`wines/${this.wineForm.edited_wine.id}?lang=${this.$i18n.locale}`, {
          params: {
            include:
              'template.grapes-composes-wine-template.grape.grape-variety,' +
              'template.appellation,' +
              'template.region,' +
              'template.country,' +
              'template.domain.region.country,' +
              'grapes-composes-wine.grape.grape-variety,' +
              'wine-labels,' +
              'appellation',
          }
        });
        
        this.wineToEdit = await Wine.query().whereId(this.wineForm.edited_wine.id).withAllRecursive().first();

        let template = this.wineToEdit.template;
        this.wineToEdit.designation = template.designation;
        this.wineToEdit.color = template.color;
        this.wineToEdit.domain = template.domain;
        this.wineToEdit.region = template.region;
        this.wineToEdit.country = template.country;
      }


      if (this.wineForm.state !== 'pending') {
        this.$toastr.e(this.$t('intranet.validation.wineFormAlreadyProcessed'), this.$t('intranet.title.wineFormAlreadyProcessed'));
        this.$router.push(`/authenticated/wine-forms/list`);
      } else {
        this.dataLoaded = true;
      }
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
